export default {
  title: "Voice agent transcripts",
  description:
    "Kiosk conversations for product review. No device or guest identity is stored.",
  empty: "No transcripts yet.",
  loadError: "Could not load transcripts",
  detailLoadError: "Could not load this transcript",
  selectPrompt: "Select a conversation to read it.",
  endedWith: {
    user_stop: "Ended by guest",
    error: "Error",
    time_limit: "Time limit",
  },
  meta: {
    language: "Language",
    duration: "Duration",
    turns: "Turns",
    activities: "Recommended activities",
    none: "None",
  },
  roles: {
    user: "Guest",
    assistant: "Agent",
    recommendations: "Recommended",
  },
} as const;
